module.exports = function(bootstrap) {
    bootstrap.run(["Service", function (Service) {
        return new Service({
            name: 'employerChangePassword',
            group: "rbsmbl",
            url: "/rbsmbl/x-services/updateProfile/updateUserProfile",
            postData: function(brand,userName,currentPassword,newPassword) {
                return this.post({
                    baseMessage: {
                        headerVersion: "1.0",
                        payloadVersion: "2.0",
                        additionalInfo: null
                    },
                    payload:{
                        "loginRequestInstance": {
                            "brand": brand,
                            "username": userName,
                            "oldPassword": currentPassword,
                            "newPassword": newPassword
                        }
                    }
                });
            }
        });
    }]);
};
